// extracted by mini-css-extract-plugin
export default {"product":"ProductMenu_product__jQR+j","productName":"ProductMenu_productName__p91gu","productIcon":"ProductMenu_productIcon__yjYpK"};